import React, { useContext } from 'react'
import { LanguageContext } from '../../../App'

const QuantityError = () => {
    const { language } = useContext(LanguageContext)
    return (
        <div className='outOfStock-mainDiv'>
            <div>
                <div className='warning-icon'>
                    !
                </div>
                <div>
                    {language === "ltr" ? "You’re Adding the last peice of this item." : "هذه آخر قطعة بإمكانك إضافتها في سلة التسوق."}
                </div>
            </div>
        </div>
    )
}

export default QuantityError